import {
  chatChannel,
  is_connect
} from "./chat"
import {
  disp_spinner_button,
  disp_spinner_button_with_disable,
  disp_spinner_icon
} from "../common/ui"

export {
  submit_message,
  submit_message_with_ai,
  submit_reply_message,
  submit_ai_message
}


async function submit_message(body_selector, image_selector, tags_selector) {
  disp_spinner_button_with_disable("#chatsubmit", "#chatsubmit_with_ai", true);
  if (!is_connect) {
    alert("接続中のためもう少し経ってからお試しください");
    disp_spinner_button_with_disable("#chatsubmit", "#chatsubmit_with_ai", false);
    return false;
  }

  var body = $(body_selector).val();
  var tags = $(tags_selector).val();

  var image = await get_image_uri(image_selector).catch(e => {
    console.log('onload error', e);
  });

  if (!body && !image) {
    disp_spinner_button_with_disable("#chatsubmit", "#chatsubmit_with_ai", false);
    return false;
  }

  chatChannel.speak(body, image, tags);
  clear_input_value(body_selector, image_selector, tags_selector);
}

async function submit_message_with_ai(body_selector, image_selector, tags_selector) {

  disp_spinner_button_with_disable("#chatsubmit_with_ai", "#chatsubmit", true);

  if (!is_connect) {
    alert("接続中のためもう少し経ってからお試しください");
    disp_spinner_button_with_disable("#chatsubmit_with_ai", "#chatsubmit", false);
    return false;
  }

  var body = $(body_selector).val();
  var tags = $(tags_selector).val();

  var image = await get_image_uri(image_selector).catch(e => {
    console.log('onload error', e);
  });

  if (!body && !image) {
    disp_spinner_button_with_disable("#chatsubmit_with_ai", "#chatsubmit", false);
    return false;
  }

  // メッセージ送信完了を待ち、そのメッセージに対してAI応答を要求
  $(document).one('received_speak', function(e, data) {
    const messageId = data.message.id;
    if (messageId) {
      chatChannel.query_chat_ai(messageId);
      // AI応答完了後にボタンを復帰
      $(document).one('received_ai', function() {
        disp_spinner_button_with_disable("#chatsubmit_with_ai", "#chatsubmit", false);
      });
    } else {
      // メッセージIDが取得できない場合ボタンを復帰
      disp_spinner_button_with_disable("#chatsubmit_with_ai", "#chatsubmit", false);
    }
  });

  chatChannel.speak(body, image, tags);
  clear_input_value(body_selector, image_selector, tags_selector);
}

async function submit_reply_message(body_selector, image_selector, tags_selector, parent_message_id) {
  if (!is_connect) {
    alert("接続中のためもう少し経ってからお試しください");
    return false;
  }

  var body = $(body_selector).val();
  var tags = $(tags_selector).val();
  var image = await get_image_uri(image_selector).catch(e => {
    console.log('onload error', e);
  });

  if (!parent_message_id || (!body && !image)) {
    return false;
  }

  chatChannel.reply(body, image, tags, parent_message_id);
  clear_input_value(body_selector, image_selector, tags_selector)

}

async function submit_ai_message(parent_message_id) {
  var icon_selector = `.message_content[data-message_id="${parent_message_id}"] .ai_button`;
  var icon = $(icon_selector);

  if (icon.prop("disabled")) {
    return;
  }

  disp_spinner_icon(icon_selector, true);

  if (!is_connect) {
    alert("接続中のためもう少し経ってからお試しください");
    disp_spinner_icon(icon_selector, false);
    return;
  }

  chatChannel.query_chat_ai(parent_message_id);

}

function get_image_uri(image_selector) {
  return new Promise((resolve, reject) => {

    if (!image_selector) {
      resolve(null)
      return;
    }

    var image_dom = $(image_selector)

    if (image_dom && image_dom.get(0).files.length > 0) {

      var file_reader = new FileReader();
      var image_blob = image_dom.get(0).files[0];
      file_reader.readAsDataURL(image_blob);

      file_reader.onload = function (e) {
        resolve(file_reader.result) // image uri
      }
      file_reader.onerror = function (e) {
        reject(e)
      }
    } else {
      resolve(null)
      return;
    }
  })
}

function clear_input_value(body_selector, image_selector, tags_selector) {
  $(body_selector).val("");
  $(image_selector).val("").change();
  $(tags_selector).val("").change();
}